import React from "react";
import { P_Props } from "./Notification.type";
import { Dialog } from "@material-ui/core";
import clsx from "clsx";

const NotificationPresenter: React.FC<P_Props> = (props) => {
  const classes = clsx({ "notification-comp": true, [props.className || ""]: Boolean(props.className) });

  return (
    <Dialog className={classes} open={props.visible}>
      <div className="notification-comp__inner">
        <div className="notification-comp__inner__icon">{props.icon}</div>
        <div className="notification-comp__inner__title">{props.title}</div>
        <div className="notification-comp__inner__sub-title">{props.subTitle}</div>
        <div className="notification-comp__inner__actions">{props.actions}</div>
      </div>
    </Dialog>
  );
};

export default NotificationPresenter;
